import React, { Component } from 'react';
import { Link } from 'react-router';
import { Carousel } from 'react-bootstrap';
import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class WebBanners extends Component{
	constructor(props){
		super(props);
		this.state={
			totcount:'',
			ads:[],
		}
		this.fetchads=this.fetchads.bind(this);
    	this.ads_count=this.ads_count.bind(this);
	}
	componentDidMount()
	{
		this.fetchads();
	}
	ads_count(ad_id)
	{
	    if(localStorage.user_id)
	    {
	      var uid=localStorage.getItem('user_id');
	    }
	    else
	    {
	      uid=0;
	    }
	    var data1={'from':3,'ad_id':ad_id,'id':uid};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	        method:'POST',
	        dataType:'json',
	        data:{req:data2},
	        url:baseUrl+'load_ad',
	        success:function(data)
	        {

	        },
	        error:function(data)
	        {

	        }
	    });
	}
  	fetchads()
  	{
	    if(localStorage.user_id)
	    {
	      var uid=localStorage.user_id;
	    }
	    else
	    {
	      uid=0;
	    }
	    var data1={'id':uid,'width':400,'height':200,'from': 3};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	        method:'POST',
	        dataType:'json',
	        data:{req:data2},
	        url:baseUrl+'getAd',
	        success:function(data)
	        {
	          this.setState({
	            ads:data.imgs,
	          });
	        }.bind(this),
	        error:function(err)
	        {
	          console.log(err);
	        }
	    });
	}
	render(){
		return(
			<div>
			{this.state.ads.length > 0  ? 
			<div>
				{/* slideshow start */}
				<div className="container_fluid ad_slideshow">
					<Carousel className="" id="carousel-main-slide" pauseOnHover={false} indicators={true}>
	                    {this.state.ads.map(function(ad, index) {
	                      var ad_deal = '';
	                      var link='';
	                      if(ad.link ==="")
	                      {
	                          link='';
	                      }
	                      else if(ad.link!=='')
	                      {
	                        link = ad.link;
	                      }
	                        
	                      if(ad.type === "Product")
	                      {
	                        ad_deal= "/web/subdeals/"+ad.url_dtype+"/"+ad.url_cat_name+"/"+ad.url_brand_name+"/"+ad.pid;
	                      }
	                      else if(ad.type === "All Seed Deals" && ad.id ==='0'){
	                        ad_deal="/web/seed";
	                      }
	                      else if(ad.type==="All Seed Deals" && ad.id > 0){
	                        ad_deal="/web/seed/"+ad.url_dtype+"/"+ad.id;
	                      }
	                      else if (ad.type ==="p_sub_category"){
	                      	var deal_ids='';
	                      	if(typeof(ad.deal_id)  != "undefined" && ad.deal_id != ''){
	                      		deal_ids = ad.deal_id;
							}else{
								deal_ids = '';
							}
	                        ad_deal="/web/pdeals/"+ad.url_dtype+"/"+ad.url_cat_name+"/"+ad.tid+"/Pcategory/"+ad.dtype+"/"+deal_ids;
	                      }
	                      else if(ad.type === "Pcategory"){
	                        ad_deal="/web/pdeals/"+ad.url_name+"/all/"+ad.id;
	                      }
	                      // else if(ad.type === 'ad-guarantee')
	                      // {
	                      	// ad_deal = '/web/pdeals/';
	                      	 // /pdeals/health-care/synergy-biotech/198/brand/4
	                      // }
	                      else if(ad.type ==="SeedDeals"){
	                        ad_deal="/web/sdetails/"+ad.url_dtype+"/"+ad.id;
	                      }
	                      else if(ad.type === "brand")
	                      {
	                        ad_deal = "/web/pdeals/"+ad.url_dtype+"/"+ad.url_ad_title+"/"+ad.tid+"/"+ad.type+"/"+ad.dtype;
	                      }
	                      else if(ad.type==="FeedDeals"){
	                        // ad_deal="/pdetails/health-care/gybro-chemicals/geolite/788/403"
	                        ad_deal="/web/pdetails/"+ad.url_dtype+"/"+ad.url_cat_name+"/"+ad.url_ad_title+"/"+ad.pid+"/"+ad.deal_id;
	                      }
	                      else if(ad.type === "Deal Offer Types"){
	                        ad_deal = "/web/pdeals/"+ad.url_dtype+"/"+ad.url_ad_title+"/"+ad.url_ad_type+"/offers/"+ad.id;
	                      }
	                      else if(ad.type === "All Product Deals"){
	                        //ad_deal = 'home';
	                        ad_deal = "/web/offers/deals/"+ad.dis_val+"/"+ad.dis_opr+"/"+ad.dis_type;
	                      }
	                      else if(ad.type==="PromoOffer"){
	                        ad_deal="/web/offerszone";
	                      }
	                      else if(ad.type==="brand_details")
	                      {
	                        ad_deal="/web/"+ad.bname+"/brand-details/"+ad.dtype+"/"+ad.bid;
	                      }
	                       else if(ad.type === 'partner')
		                  {
		                    ad_deal="/web/pdeals/partner/"+ad.tid;
		                  }
		                  else if(ad.type === 'caa-approved' || ad.type === 'ad-guarantee' || ad.type=== 'ad-assist' )
		                  {
		                    if(ad.tid==='0')
		                    {
		                      ad_deal='/web/ad-banners/'+ad.type;
		                    }
		                    else
		                    {
		                      ad_deal="/web/stores/"+ad.type+'/'+ad.tid;  
		                    }
		                  }
	                      else
	                      {
	                        ad_deal="/web/home";
	                      }

	                    return (
                            <Carousel.Item key={index} >
                                <Carousel.Caption className="webCarousel_count ">{ad.sno}/{this.state.ads.length}</Carousel.Caption>
                                  {link==='' ?  
                                    <Link onClick={()=> this.ads_count(ad.ad_id)} to={ad_deal} className="item">
                                          <img className="webbanner_img" src={baseAssets+'images/ad_imgs/ad_imgs_web/'+ad.img} alt="..."/> 
                                    </Link> : 
                                    <a onClick={()=> this.ads_count(ad.ad_id)} href={link} target="_blank" className="item">
                                      <img className="webbanner_img" src={baseAssets+'images/ad_imgs/ad_imgs_web/'+ad.img} alt="..."/>
                                    </a>
                                  }
                                </Carousel.Item>
                              )}.bind(this))}
                      		</Carousel>
					</div>
				{/* slideshow end */}
			</div>

			 : ''}
			</div>

		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/WebBanners.js
 **/